import { ModelSagres } from "../model-sagres";

export class ArquivoLicitacao extends ModelSagres {
  IdArquivo: number;
  IdLicitacao: number;
  DePathArqEdital: string;
  NmArquivo: string;
  NmUsuarioResponsavel: string;
  DtInsercao: Date;
  IdTipoArquivo: number;
}
